import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/Col";

export const Footer = () => {
  return (
    <Container className="p- fixed-bottom bg-white">
      <small className="footer-copyright-links">
          <div className="d-flex justify-content-center align-items-center">
              <div className="footer-copyright">
                <p>Copyright © 2024 allhomedesire. All rights reserved.</p>
              </div>
              <div className="footer-policy-links">
                <ul>
                  <li>
                    <Link to="/Policy">Privacy & Policy</Link>
                  </li>
                  <li>
                    <Link to="/policy">Terms & Condition</Link>
                  </li>
                </ul>
              </div>
          </div>
      </small>
    </Container>
  );
};
export default Footer;
